import React, {useEffect, useState} from "react";
import {
    Button,
    Card,
    CardActions,
    CardContent,
    CircularProgress,
    Fade,
    Grid,
    IconButton,
    Modal,
    TextField,
    Typography,
} from "@material-ui/core";
import {withRouter} from "react-router-dom";
import Alert from '@material-ui/lab/Alert';

import {Footer} from '../../components/Footer/Footer'

// styles
import useStyles from "./styles";

// logo
// context
import {connect} from "react-redux";
import {login, sendPasswordRequest} from "../../datamanagement/actions";
import {Close} from "@material-ui/icons";
import Header from "../../components/Header/Header";
import {CookieSnackbar} from "../../components/CookieSnackbar/CookieSnackbar";

function Login(props) {

    useEffect(() => {
        document.title = 'Anmelden - JobNinja Kundendashboard'
    })

    var classes = useStyles();

    // local
    var [loginValue, setLoginValue] = useState("");
    var [passwordValue, setPasswordValue] = useState("");

    const [modalOpen, setModalOpen] = useState(props.user.resetPasswordModalOpen);
    const [resetPasswordEmail, setResetPasswordEmail] = useState("");
    const message = props.user.login.message

    const isLoading = props.user.login.loading

    const handleModalClose = () => {
        setModalOpen(false)
    }

    const submitLogin = (e) => {
        e.preventDefault()
        props.login(
            loginValue,
            passwordValue,
            props.history
        )
    };

    const validateEmail = (e) => {
        return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(e);
    }

    function getMessageAlert() {
        return !!message && <Alert severity={message.type.toString()}>{message.payload.toString()}</Alert>;
    }

    return (
        <>
            {(props.loading) ? <CircularProgress color="secondary"/> :
                <Grid className={classes.container}>
                    <Grid className={classes.subcontainer}>
                        <Header history={props.history}/>
                        <div className={classes.formContainer}>
                            <div className={classes.form}>
                                <form onSubmit={submitLogin}>
                                    <React.Fragment>
                                        {getMessageAlert()}
                                        <Typography variant="h1" className={classes.greeting}>
                                            Willkommen!
                                        </Typography>
                                        <br/>
                                        <TextField
                                            id="email"
                                            InputProps={{
                                                classes: {
                                                    underline: classes.textFieldUnderline,
                                                    input: classes.textField,
                                                },
                                            }}
                                            value={loginValue}
                                            onChange={e => setLoginValue(e.target.value)}
                                            margin="normal"
                                            placeholder="E-Mail Adresse"
                                            type="email"
                                            fullWidth
                                        />
                                        <TextField
                                            id="password"
                                            InputProps={{
                                                classes: {
                                                    underline: classes.textFieldUnderline,
                                                    input: classes.textField,
                                                },
                                            }}
                                            value={passwordValue}
                                            onChange={e => setPasswordValue(e.target.value)}
                                            margin="normal"
                                            placeholder="Passwort"
                                            type="password"
                                            fullWidth
                                        />
                                        <div className={classes.formButtons}>
                                            {isLoading ? (
                                                <CircularProgress size={26} className={classes.loginLoader}/>
                                            ) : (
                                                <Button
                                                    type="submit"
                                                    disabled={
                                                        loginValue.length === 0 || passwordValue.length === 0 || !validateEmail(loginValue)
                                                    }
                                                    color="secondary"
                                                    size="large"
                                                >
                                                    Anmelden
                                                </Button>
                                            )}
                                            <Button
                                                color="secondary"
                                                size="small"
                                                onClick={() => setModalOpen(true)}
                                            >
                                                Passwort vergessen
                                            </Button>
                                        </div>
                                    </React.Fragment>
                                </form>
                            </div>
                        </div>
                        <Modal
                            open={modalOpen}
                            onClose={handleModalClose}
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                        >
                            <Fade in={modalOpen} timeout={500}>
                                <Card className={classes.modalRoot}>
                                    <IconButton onClick={handleModalClose} className={classes.modalExit}>
                                        <Close/>
                                    </IconButton>
                                    <form onSubmit={(e) => {
                                        e.preventDefault()
                                        props.sendPasswordRequest(
                                            resetPasswordEmail
                                        )
                                        handleModalClose()
                                    }}>
                                        <CardContent>
                                            <Typography gutterBottom variant="h5" component="h2">
                                                Passwort zurücksetzen
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary" component="p">
                                                Bitte geben Sie die E-Mail an, die Sie für die Anmeldung verwenden,
                                                damit
                                                wir Ihnen
                                                einen Reset-Link senden können.</Typography>
                                            <br/>
                                            <TextField
                                                InputProps={{
                                                    classes: {
                                                        underline: classes.textFieldUnderline,
                                                        input: classes.textField,
                                                    },
                                                }}
                                                value={resetPasswordEmail}
                                                onChange={e => setResetPasswordEmail(e.target.value)}
                                                margin="normal"
                                                placeholder="E-Mail Adresse"
                                                type="email"
                                                fullWidth
                                            />
                                        </CardContent>
                                        <CardActions>
                                            <Button
                                                variant="contained"
                                                size="medium"
                                                color="secondary"
                                                type="submit"
                                                disabled={resetPasswordEmail.length === 0 || !validateEmail(resetPasswordEmail)}
                                            >
                                                Senden
                                            </Button>
                                        </CardActions>
                                    </form>

                                </Card>
                            </Fade>
                        </Modal>
                    </Grid>
                    <Grid className={classes.footer}>
                            <Footer/>
                    </Grid>
                    <CookieSnackbar/>
                </Grid>
            }
        </>
    );
}

const mapStateToProps = ({user}) => {
    return {user};
}

const mapDispatchToProps = dispatch => {
    return {
        login: (username, password, history) => login(dispatch, username, password, history),
        sendPasswordRequest: (emailValue) => sendPasswordRequest(dispatch, emailValue),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Login));

